import { api } from '@/lib/http-client';
import { normalizeCatalogo, type CatalogoData } from './catalogo.types';

/** Cuántos modelos trae cada página (grid 1/2/3 col sin scroll infinito). */
export const CATALOGO_POR_PAGINA = 12;

/**
 * Catálogo público: `GET /api/catalogo/:slug?pagina=N&porPagina=M&buscar=...` SIN JWT (auth: false).
 * Usa el cliente central para desempaquetar el envelope `{ success, data }`.
 */
export async function fetchCatalogo(
  slug: string,
  opciones: { pagina?: number; porPagina?: number; buscar?: string; signal?: AbortSignal } = {},
): Promise<CatalogoData> {
  const { pagina = 1, porPagina = CATALOGO_POR_PAGINA, buscar = '', signal } = opciones;
  const data = await api.get<unknown>(`/api/catalogo/${encodeURIComponent(slug)}`, {
    auth: false,
    signal,
    query: {
      pagina,
      porPagina,
      ...(buscar.trim() ? { buscar: buscar.trim() } : {}),
    },
  });
  return normalizeCatalogo(data);
}

/** Mensaje prellenado del botón «Quiero este modelo» (nombre + referencia). */
export function buildModeloMessage(nombre: string, referencia?: string | null): string {
  const ref = referencia?.trim() ? ` (ref: ${referencia.trim()})` : '';
  return `Hola, quiero este modelo: ${nombre}${ref}. ¿Sigue disponible?`;
}

/**
 * Enlace de WhatsApp del modelo.
 * Sin `waNumber` devuelve el enlace genérico de WhatsApp (la página lo avisa).
 */
export function buildWaLink(waNumber: string | null | undefined, mensaje: string): string {
  const numero = waNumber?.replace(/\D/g, '');
  if (!numero) return 'https://wa.me/?text=' + encodeURIComponent(mensaje);
  return `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
}

/**
 * Moneda es-CO sin símbolo (igual que el panel: el negocio no tiene moneda
 * configurada, ver `products-format.ts`). `null` = «precio a consultar».
 */
export function formatPrecioDesde(value: number | null | undefined): string | null {
  if (value === null || value === undefined) return null;
  return `Desde $${value.toLocaleString('es-CO', { maximumFractionDigits: 2 })}`;
}
